import { useState } from "react";
import { AlertOctagon } from "react-feather";
import { Alerts, Btn, P } from "../../../../AbstractElements";

const InsetOutline = () => {
  const [active, setActive] = useState(true);
  return (
    <Alerts color="transparent" isOpen={active} className={`txt-danger inset-border border-danger outline-2x alert-dismissible fade show alert-icons`}>
      <AlertOctagon />
      <P className="txt-danger">The <b className="txt-danger">"inset-border" </b>with <b className="txt-danger">"border-danger" </b>class has the ability to generate on its own alerts.</P>
      <Btn color="transperant" close onClick={() => setActive(false)} />
    </Alerts>
  );
};

export default InsetOutline;
